import React from 'react'
import { FeedSC } from './feed.styled'
import useUserRecords from '../../hooks/useUserRecords'
import FeedStatus from '../../components/lib/feed-status'
import useUserDetail from '../../hooks/useUserDetail'

import {
  IUserApprovedPayload,
  IUserRejectedPayload,
  IUserEvaluationPayload,
  IUserHasEvisitPayload,
  IUserHasNotEvisitPayload,
} from '../../types/feed'

import Loader from '../../components/lib/loader'
import FeedStatusAction from '../../components/lib/FeedStatusAction/FeedStatusAction'
import FeedAddEVisit from '../../components/lib/FeedAddEVisit'
import AddRunningRecord from '../../components/AddRunningRecord'
import FeedRunningRecord from '../../components/lib/FeedRunningRecord'

export const Feed: React.FC = () => {
  const { data: userRecordsData, isLoading: isUserRecordsLoading } = useUserRecords()
  const { data: userDetailData, isLoading: isUserDetailLoading } = useUserDetail()

  const isLoading = isUserRecordsLoading || isUserDetailLoading

  const { currentStepStatus, currentStepIndex, totalStepCount } = userDetailData || {}

  return (
    <FeedSC>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {currentStepStatus === 'waitingForApproval' && (
            <FeedStatusAction createdAt={new Date().toISOString()} />
          )}

          {(currentStepStatus === 'waitingForEvaluation' || currentStepStatus === 'inProgress') && (
            <AddRunningRecord
              programStep={currentStepIndex}
              totalStepCount={totalStepCount}
              createdAt={new Date().toISOString()}
            />
          )}

          {currentStepStatus === 'waitingForEtermin' && (
            <FeedAddEVisit createdAt={new Date().toISOString()} />
          )}

          {userRecordsData?.map((record) => {
            const { type, createdAt, payload, stepIndex } = record
            switch (type) {
              case 'activation':
                return <FeedStatus createdAt={createdAt} statusType='activation' key={createdAt} />
              case 'approval': {
                const { approve, note } = payload as IUserApprovedPayload | IUserRejectedPayload
                if (!approve) {
                  return (
                    <FeedStatus
                      createdAt={createdAt}
                      statusType='approval'
                      approved={false}
                      note={note}
                      key={`${createdAt}-approval`}
                    />
                  )
                } else {
                  return (
                    <FeedStatus
                      createdAt={createdAt}
                      statusType='approval'
                      note={note}
                      approved
                      key={`${createdAt}-approval`}
                    />
                  )
                }
              }
              case 'evaluation':
                const { risk, description, nextCheckAt, data } = payload as IUserEvaluationPayload
                return (
                  <FeedRunningRecord
                    description={description}
                    risk={risk}
                    programStep={stepIndex}
                    totalStepCount={totalStepCount}
                    createdAt={createdAt}
                    key={`${createdAt}-evaluation`}
                    nextCheckAt={nextCheckAt}
                    data={data}
                  />
                )
              case 'etermin':
                const { hasEtermin, note } = payload as
                  | IUserHasEvisitPayload
                  | IUserHasNotEvisitPayload
                return (
                  <FeedStatus
                    createdAt={createdAt}
                    note={note}
                    hasEtermin={hasEtermin}
                    statusType='etermin'
                    key={`${createdAt}-etermin`}
                  />
                )
              case 'stepStart':
                return (
                  <FeedStatus
                    createdAt={createdAt}
                    statusType='stepStart'
                    key={`${createdAt}-stepStart`}
                  />
                )
              case 'stepEnd':
                return (
                  <FeedStatus
                    createdAt={createdAt}
                    statusType='stepEnd'
                    key={`${createdAt}-stepEnd`}
                  />
                )
              default:
                return null
            }
          })}
        </>
      )}
    </FeedSC>
  )
}

export default Feed
